import { routeMap } from '@core/constants/routes'
import { useMainState } from '@core/main-state'

export const useGetDefaultAuthorRoute = () => {
  const hasItemTypesEnabled = useMainState((state) => state.customer?.features?.item_types_v2)

  if (!hasItemTypesEnabled) {
    return routeMap.AUTHOR_ROUTE
  }

  return routeMap.AUTHOR_V2_LANDING_PAGE
}

export const useGetDefaultAuthorCreateRoute = () => {
  const hasItemTypesEnabled = useMainState((state) => state.customer?.features?.item_types_v2)

  if (!hasItemTypesEnabled) {
    return routeMap.AUTHOR_ROUTE
  }

  return routeMap.AUTHOR_V2_CREATE
}
